import { useContext, useEffect, useMemo, useState } from "react";
import { departureValues } from "src/constants/common";
import { ResultsContext } from "src/context/resultsContext/context";
import { getKeyByValue } from "src/utils/generalUtils";

/**
 * @abstract: Custom hook to get the count of selected filters, list of filter that are selected or type of sort by
 */
export const useIsAnyFilterSelected = () => {
  const { selectedFilters, filterResults, filteredGovtBuses } =
    useContext(ResultsContext);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const filterKeys = Object.keys(selectedFilters);

    let count = 0;
    filterKeys.forEach((item: string) => {
      if (selectedFilters[item].length && item !== "sortBy") {
        count++;
      }
    });
    setCount(count);
  }, [selectedFilters]);

  //To get the filters list to send to clevertap
  const selectedFiltersList = (selectedFiltersList = selectedFilters) => {
    const list: Record<string, string[]> = {};
    Object.keys(selectedFiltersList).forEach((item) => {
      if (item === "departure" && selectedFiltersList[item].length > 0) {
        list[item] = selectedFiltersList[item].map((item) =>
          getKeyByValue(departureValues, item)
        ) as string[];
      } else if (item !== "sortBy" && selectedFiltersList[item].length > 0) {
        list[item] = selectedFiltersList[item] as string[];
      }
    });
    return list;
  };

  const selectedSort = useMemo(() => {
    const selectedFiltersList = selectedFilters;
    if (selectedFiltersList?.sortBy?.length) {
      return selectedFiltersList.sortBy[0];
    }
    return "";
  }, [selectedFilters]);

  const totalResults = useMemo(() => {
    const totalNormalBuses = filterResults?.buses?.length || 0;
    let totalGovtBuses = 0;

    Object.keys(filteredGovtBuses).forEach((key) => {
      if (filteredGovtBuses[key].length)
        totalGovtBuses = filteredGovtBuses[key].length + totalGovtBuses;
    });
    return totalNormalBuses + totalGovtBuses;
  }, [filterResults?.buses?.length, filteredGovtBuses]);

  return { count, selectedFiltersList, selectedSort, totalResults };
};
